import {useReducedMotion} from 'framer-motion';
import {routeErrorVariants} from '../../utilities/framerVariants';
import {motion} from 'framer-motion';
import {Link} from "react-router-dom";
import styles from './RouteError.module.scss';

const RouteError = () => {
    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? routeErrorVariants.reduced
            : routeErrorVariants[element];
    };

    return (
        <motion.div
            className={styles.container}
            variants={variant('routeError')}
            initial="hidden"
            animate="visible"
            exit="exit"
        >
            <motion.div
                className={styles.illustration}
                variants={variant('illustration')}
            />
            <motion.h1
                className={styles.title}
                variants={variant('title')}>404!
            </motion.h1>
            <h2 className={styles.subtitle}>
                Ooops! You weren't supposed to see this
            </h2>
            <p className={styles.text}>
                It looks like you've reached a URL that doesn't exist. Please
                use the button below to find your way back to our website.
            </p>
            <Link className={styles.link} to="/">
                Back to home
            </Link>
        </motion.div>
    );
};

export default RouteError;
